<template>
  <div class="TeamCard card hover">
    <div class="tc" v-on:click="editTeam">
      <img class="cardLogo" src="@/assets/overwatch_logo.png">
      <div class="teamName">{{ team.name }}</div>
      <div v-if="!teamIsEmpty && (team.teamStats != null)" class="teamRank">{{ teamRank }}</div>
      <img v-if="!teamIsEmpty && (team.teamStats != null)" class="teamRankLogo" v-bind:src="rankImage" alt="">
    </div>
    <div v-if="edit" class="del red-glow" v-on:click="remove"></div>
  </div>
</template>

<script>
export default {
  name: 'TeamCard',
  props: ["teamId", "tournamentId", "edit"],

  computed: {
    team(){
      for(var i = 0; i < this.$store.state.teams.length; i++){
        if(this.$store.state.teams[i].id == this.teamId){
          return this.$store.state.teams[i];
        }
      }
    },
    teamIsEmpty(){
      return (this.team.players.length === 0);
    },
    teamRank(){
        return Math.round(this.team.teamStats.avgRank);
      },
      
    rankImage(){
      var tier = 0;

      switch(true) {
        case (this.teamRank < 1499):
        tier = 1;
        break;
        case (1500 < this.teamRank && this.teamRank < 1999):
        tier = 2;
        break;
        case (2000 < this.teamRank && this.teamRank < 2499):
        tier = 3;
        break;
        case (2500 < this.teamRank && this.teamRank < 2999):
        tier = 4;
        break;
        case (3000 < this.teamRank && this.teamRank < 3499):
        tier = 5;
        break;
        case (3500 < this.teamRank && this.teamRank < 3999):
        tier = 6;
        break;
        case (4000 < this.teamRank):
        tier = 7;
        break;
      }
      return "https://d1u1mce87gyfbn.cloudfront.net/game/rank-icons/season-2/rank-" + tier + ".png";
    }
  },

  methods: {
    editTeam(){
      if(!this.edit){
        return
      }
      this.$router.push({ name: 'TeamPage', params: { teamId: this.team.id }})
    },
    removeTeamFromTournament(){
      this.$store.dispatch("removeTeamFromTournament",{tournamentId: this.tournamentId, teamId: this.team.id});
    },
    removeTeam(){
      this.$store.dispatch("removeTeam",this.team.id);
    },
    remove(){
      if(this.tournamentId != null){
        this.removeTeamFromTournament();
      }else{
        this.removeTeam();
      }
    }
  }
}
</script>


<style scoped>

.TeamCard{
  display: grid;
  grid-template-columns: auto 30px;
  grid-template-areas:
    'inner    remove';
}

.tc{
  grid-area: inner;
  display: grid;
  grid-template-columns:100px auto;
  grid-template-rows: 50px;
  grid-column-gap: 10px;
  grid-template-areas:
    'cardLogo teamName'
    'cardLogo teamRank';
}

.cardLogo{
  grid-area: cardLogo;
}

.teamInfo{
  grid-area: teamInfo;

  display: grid;
  grid-template-areas:
    'teamName'
    'teamRank';
}
.teamName{
  grid-area: teamName;
  font-size: 25px;
  margin-top: auto;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.teamRank{
  grid-area: teamRank;

  font-size: 20px;
  margin-top: 0px;
  margin-left: 30px;
}
.teamRankLogo{
  grid-area: teamRank;
  width: 32px;
  margin-top: 0px;
}

.del{
  grid-area: remove;
  text-align: center;
  background-image: url(../assets/removePlayer.png);
  width: 30px;
  height: 100px;
  background-size: 30px 100px
}

.del:hover{
  /*transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);

  box-shadow: 0 4px 8px 0 rgba(255, 0, 106, 0.25), 0 6px 20px 0 rgba(255, 0, 0, 0.568);*/
}

</style>



// WEBPACK FOOTER //
// src/components/TeamCard.vue